module.exports = __webpack_public_path__ + "static/media/balancei.a2c16cec.png";